export type TestCaseFromTemplate = {
  id: string;
  input: string;
  expectedOutput: string;
  timeoutMs: number;
};

export type TestCase = {
  id: string;
  input: unknown;
  expected: unknown;
  status: 'passed' | 'failed' | 'pending' | 'timeout';
  actual?: unknown;
  error?: string;
  stdout?: string;
};

// Keep this in sync with the CodeExecutionSupportedLanguage enum in the backend
export enum CodeExecutionSupportedLanguage {
  PYTHON = 'python',
  JAVASCRIPT = 'javascript',
  TYPESCRIPT = 'typescript',
  SWIFT = 'swift',
  JAVA = 'java',
  CPP = 'cpp',
  GO = 'go',
  PHP = 'php',
}

// https://github.com/microsoft/monaco-editor/tree/main/src/basic-languages
export const CODE_EXECUTION_SUPPORTED_LANGUAGE_TO_FRONTEND_LANGUAGE: Record<
  CodeExecutionSupportedLanguage,
  string
> = {
  [CodeExecutionSupportedLanguage.PYTHON]: 'python',
  [CodeExecutionSupportedLanguage.JAVASCRIPT]: 'javascript',
  [CodeExecutionSupportedLanguage.TYPESCRIPT]: 'typescript',
  [CodeExecutionSupportedLanguage.SWIFT]: 'swift',
  [CodeExecutionSupportedLanguage.JAVA]: 'java',
  [CodeExecutionSupportedLanguage.CPP]: 'cpp',
  [CodeExecutionSupportedLanguage.GO]: 'go',
  [CodeExecutionSupportedLanguage.PHP]: 'php',
};
